/**
 * Detects whether the app is running in a non-production environment.
 *
 * Returns true for:
 * - Local development (NODE_ENV !== "production")
 * - Deployed dev environment (DEPLOYMENT_ENVIRONMENT === "dev")
 *
 * Every deployed bundle is a production build (NODE_ENV === "production"), so
 * NODE_ENV alone is insufficient. Checking DEPLOYMENT_ENVIRONMENT allows
 * dev-specific behavior in the deployed dev environment while letting the prod
 * bundle DCE the dev branch.
 */
export function isNonProd(): boolean {
  const DEPLOYMENT_ENVIRONMENT =
    process.env.NEXT_PUBLIC_DEPLOYMENT_ENVIRONMENT ??
    process.env.EXPO_PUBLIC_DEPLOYMENT_ENVIRONMENT;
  return (
    process.env.NODE_ENV !== "production" || DEPLOYMENT_ENVIRONMENT === "dev"
  );
}
